module.exports = __webpack_public_path__ + "static/img/function-box-img3.234077a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedPortal/function-box-img3.png
// module id = QG4y
// module chunks = 0